import { GARAN_HEADLINE } from '../../garan.config';

/**
 * Hidden heading text used to expose the GARAN brand for screen readers.
 */
export const Headline = () => <span className="sr-only">{GARAN_HEADLINE}</span>;
